import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./PageHome.css";

function PageHome() {
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleGetStarted = () => {
    if (checked) {
      navigate("/shop");
    } else {
      alert("Please confirm you are over 25 years old.");
    }
  };

  return (
    <div className="container">

      {/* Animated Background */}
      <div className="animated-bg">
        <div className="bg-shape shape1"></div>
        <div className="bg-shape shape2"></div>
        <div className="bg-shape shape3"></div>
        <div className="bg-shape shape4"></div>
      </div>

      {/* Content */}
      <div className="content-wrapper">

        <img
          src="../images/logo.png"
          alt="Logo"
          className="logo"
        />

        <h1>Book Your Liquor</h1>

        <div className="warning-box">
          <strong>⚠️ Statutory Warning</strong>
        </div>

        <div className="box">
          <p>
            I understand that the minimum legal age for consuming and
            purchasing alcohol as per law in Delhi is 25 years. I hereby
            confirm that I am over 25 years of age and I undertake to remain
            compliant with all the applicable laws in Delhi for purchasing
            and consuming alcohol. DSIIDC Liquor Booking app is owned by
            "DSIIDC LTD."
          </p>
        </div>

        <div className="checkbox-row">

          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={checked}
              onChange={() => setChecked(!checked)}
            />

            I am over 25 years of age
          </label>

          <a
            href="https://gitstool.in/liquor/shop_app/alert.html"
            className="compliance-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>

        </div>

        <button
          className={`get-started ${checked ? "active" : ""}`}
          onClick={handleGetStarted}
          disabled={!checked}
        >
          Get Started
        </button>

      </div>
    </div>
  );
}

export default PageHome;